import React from 'react';

export interface VerbRailAction {
  label: string;
  onPress: () => void;
  variant?: 'primary' | 'secondary' | 'destructive';
  icon?: React.ReactNode;
  disabled?: boolean;
}

export interface VerbRailProps {
  actions: VerbRailAction[];
  size?: 'sm' | 'md';
  className?: string;
}

const HEIGHT: Record<'sm' | 'md', string> = {
  sm: 'h-8',
  md: 'h-10',
};

const VARIANT_CLASSES: Record<'primary' | 'secondary' | 'destructive', string> = {
  primary: 'bg-accent text-white border-transparent hover:opacity-90 active:opacity-75',
  secondary:
    'border border-border-light text-text-secondary hover:text-text-primary hover:border-border-medium active:opacity-75',
  destructive:
    'border border-destructive/40 text-destructive hover:border-destructive/60 active:opacity-75',
};

export function VerbRail({ actions, size = 'md', className }: VerbRailProps) {
  const capped = actions.slice(0, 3);
  const equalWidth = capped.length >= 2;

  return (
    <div className={`flex flex-row gap-2 ${className ?? ''}`}>
      {capped.map((action, idx) => {
        const variant = action.variant ?? 'secondary';
        return (
          <button
            key={action.label}
            type="button"
            disabled={action.disabled}
            onClick={action.onPress}
            className={[
              'inline-flex items-center justify-center gap-1.5 rounded-lg px-3 text-sm font-semibold',
              'transition-colors min-h-[44px]',
              HEIGHT[size],
              VARIANT_CLASSES[variant],
              equalWidth ? 'flex-1' : '',
              action.disabled ? 'opacity-40 pointer-events-none' : '',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            {action.icon && (
              <span className="flex-shrink-0 w-4 h-4" aria-hidden="true">
                {action.icon}
              </span>
            )}
            {action.label}
          </button>
        );
      })}
    </div>
  );
}
